module.exports = __webpack_public_path__ + "img/aw-mobile-default.37a11d1e.png";